module.exports = __webpack_public_path__ + "img/317.854bc885.png";